import { ProjectOverviewActionType } from '../actionTypes/projectOverview';
import { GET_PROJECT_OVERVIEW } from '../actions/types';
import { PostDispatch, ProjectModel, ProjectOverview } from '../types';
import { INITIAL_PROJECT_OVERVIEW } from '../../utils/state';

const reducer = (
    state: ProjectOverview = INITIAL_PROJECT_OVERVIEW,
    action: PostDispatch
) => {
    switch (action.type) {
        case GET_PROJECT_OVERVIEW:
            return action.payload;
        case ProjectOverviewActionType.GET_INVOLVED_PROJECTS:
            return action.payload['projectsOverview'];
        case ProjectOverviewActionType.WITHDRAW_PROJECT: {
            const projectsWithoutWithdrawnProject = state.projects.filter(
                (p) => p._id !== (action.payload as ProjectModel)?._id
            );
            return {
                ...state,
                projects: [...projectsWithoutWithdrawnProject],
            };
        }
        default:
            return state;
    }
};

export default reducer;
